import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { getDimensionColor } from "./dimension-color";
export class Dimension extends Model {
  dimensionKey = ""; // 维度键 customDimension1
  dimensionName = ""; // 维度名
  dimensionNameEn = ""; // 维度名英文
  dimensionDesc = ""; // 维度描述
  companyId = 0; // 公司id
  isSystemDimension = 0; // 是否是系统标准维度 1是
  isFromSystemDimension = 0; // 是否是历史公有维度保留 1是
  questionCount = 0; // 当前维度题库题目数量
  questionsIsExamUsed = 0; // 维度下题目是否被面试使用 1是
  checked = false; //是否已选
  defaultChecked = false; //默认选中不可改

  //是否不在考试中
  notInExam = false;
  backgroundColor = "";
  color = "";

  // 创建面试v3增加字段
  dimensionParentGroupId = 0; // 维度父级分类id
  dimensionParentGroupName = ""; // 维度父级分类名称
  dimensionParentGroupDesc = ""; // 维度父级分类描述

  assign(data: any): any {
    const instance = super.assign(data);
    const colorConfig = getDimensionColor(this.dimensionKey);
    instance.backgroundColor = colorConfig["background-color"];
    instance.color = colorConfig["color"];
    return instance;
  }
}

export class DimensionRes extends Model {
  count = 0;
  list: Dimension[] = [new Dimension()];
  noDimensionQuestionCount = 0;
  allQuestionCount = 0;
}
export default class Dimensions extends Model {
  static get(params: any) {
    return request.post("aiExam/dimension/list", params).then(resp => {
      return new DimensionRes(resp).assign(resp.data.data);
    });
  }

  static tacGet(params: any, tacToken: string) {
    return request
      .post("tac/template/redirect", {
        path: "/aiExam/dimension/list",
        tacToken,
        request: params
      })
      .then(resp => {
        return new DimensionRes(resp).assign(resp.data.data);
      });
  }

  static getAll(p: any) {
    return request.post("aiExam/dimension/list", p).then(resp => {
      return new DimensionRes(resp).assign(resp.data.data);
    });
  }
  static create(params: {}) {
    return request.post("aiExam/dimension/create", params).then(resp => {
      return resp;
    });
  }
  static update(params: {}) {
    return request.post("aiExam/dimension/update", params).then(resp => {
      return resp;
    });
  }
  static delete(params: {}) {
    return request.post("aiExam/dimension/delete", params).then(resp => {
      return resp;
    });
  }
}
